export function brazilianTelephoneMask(value = '', defaultEmptyReturn = ''): string {
  if (!value) return defaultEmptyReturn

  const cleanedValue = value.replace(/\D/g, '').slice(0, 11)
  const length = cleanedValue.length

  if (length === 0) return ''
  if (length < 3) {
    return `(${cleanedValue}`
  }
  if (length < 7) {
    return `(${cleanedValue.slice(0, 2)}) ${cleanedValue.slice(2)}`
  }
  if (length < 11) {
    const isCellPhone = length > 10
    const part1 = cleanedValue.slice(0, 2)
    const part2 = cleanedValue.slice(2, isCellPhone ? 7 : 6)
    const part3 = cleanedValue.slice(isCellPhone ? 7 : 6)
    return `(${part1}) ${part2}-${part3}`
  }

  // Quando tiver exatamente 11 dígitos (celular com 9 na frente)
  return cleanedValue.replace(/(\d{2})(\d{5})(\d{4})/, '($1) $2-$3')
}
